
export default class TrainingInstitutionLite {

    id!: number;
    name!: string;
    compartmentName!: string;

    public static fromResponse(data: any): TrainingInstitutionLite {

        const result: TrainingInstitutionLite = new TrainingInstitutionLite();

        if (data.id != undefined) {
            result.id = data.id;
        }

        if (data.name != undefined) {
            result.name = data.name;
        }

        if (data.compartmentName != undefined) {
            result.compartmentName = data.compartmentName;
        }

        return result;

    }

}